// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

//portal: 'portal-onboardingdev.bigredsky.com',
//Services v2 API: https://services-v2.bigredsky.com/BigRedSkyOnboarding/OnboardingPortalAPI/web/index.php/api/

export const environment = {
  production: true,
  version: '1.0.53',
  API_ENDPOINT: 'https://services-v7.bigredsky.com/BigRedSkyOnboarding/OnboardingPortalAPI/web/index.php/api/',
  platform: '',
  gaID: 'UA-102615324-1'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts